import cn from 'classnames';
import * as st from './styles.module.scss';

interface Props {
	size: 'small' | 'large';
	className?: string;
}

export const EventEnd = ({ size, className }: Props): JSX.Element => {
	/**
	 * TODO: Как станет известно насчет того будет ли отличаться текст в зависимости от размера экрана, внести соответствующие изменения
	 */
	return (
		<div
			className={cn(
				className,
				st.wrapper,
				st.close,
				(size === 'small' && st.small) || (size === 'large' && st.large)
			)}
		>
			<p className={st.mobile}>Завершено</p>
			<p className={st.desktop}>Завершено</p>
		</div>
	);
};